module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center3"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("JON:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To my parents, whose bookshelves, patience, and support")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("(as well as willingness to take trips to battlefields and historic sites!)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("guided me to this point and continue to help me.")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("CHRIS:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To Sarah Kay Bierle, ECW’s managing editor—")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("this book series is a monument to her years of hard work and daily oversight of Emerging Civil War’s blog.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("None of this would be possible without her.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e79a29c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Epigraph.vue
// module id = 69
// module chunks = 0